__turbopack_context__.v({
  "controls": "ItineraryCardNightStepper-module__lLTPnW__controls",
  "count": "ItineraryCardNightStepper-module__lLTPnW__count",
  "label": "ItineraryCardNightStepper-module__lLTPnW__label",
  "labelIcon": "ItineraryCardNightStepper-module__lLTPnW__labelIcon",
  "labelText": "ItineraryCardNightStepper-module__lLTPnW__labelText",
  "stepper": "ItineraryCardNightStepper-module__lLTPnW__stepper",
  "stepperButton": "ItineraryCardNightStepper-module__lLTPnW__stepperButton",
});
